import type {
  AssessmentFilterState,
  AssessmentLevel,
  EnterpriseFilterState,
  ReportPage,
} from "./types";

/**
 * Query-key factory for the reports slice. Every list keys off its filter
 * state so changing a filter refetches; a shared `all` root allows blanket
 * invalidation.
 */
export const reportKeys = {
  all: ["reports"] as const,
  options: () => [...reportKeys.all, "filter-options"] as const,
  enterprises: (filters: EnterpriseFilterState, page: number) =>
    [...reportKeys.all, "enterprises", filters, page] as const,
  enterprise: (id: string) => [...reportKeys.all, "enterprise", id] as const,
  progress: (filters: EnterpriseFilterState, page: number) =>
    [...reportKeys.all, "progress", filters, page] as const,
  assessmentSummary: (filters: AssessmentFilterState) =>
    [...reportKeys.all, "assessment", "summary", filters] as const,
  assessmentData: (
    filters: AssessmentFilterState,
    level: AssessmentLevel,
    parentId: string | null,
  ) =>
    [...reportKeys.all, "assessment", "data", level, parentId, filters] as const,
  facets: (page: ReportPage, filters: object) =>
    [...reportKeys.all, "facets", page, filters] as const,
} as const;
